export const getUserMetaTitle = (username, language) => {
  if (username && language) {
    if (language === 'ru-RU') {
      return `Купить NFT у ${username}`
    } else {
      return `Buy NFT from ${username}`;
    }
  }

  return '';
}

export const getUserMetaDescription = (username, language) => {
  if (username && language) {
    if (language === 'ru-RU') {
      return `Купить NFT от ${username}, уникальные аукционы и минт новых NFT коллекций ${username}`;
    } else {
      return `Buy NFT from ${username}, unique auctions and mint of ${username}'s new NFT collections`;
    }
  }

  return '';
}